import { render, staticRenderFns } from "./AddEditSysconfig.vue?vue&type=template&id=4a132810&scoped=true"
import script from "./AddEditSysconfig.vue?vue&type=script&lang=js"
export * from "./AddEditSysconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a132810",
  null
  
)

export default component.exports